function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 560;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/platform/instantiation/common
// module id = 560
// module chunks = 0